// Slice
export const SLICE_NAME_FORECAST_CONFIG = 'forecastConfig'
